import { callServer, ClientOptions, utils } from "postmessage-promise";
import { v4 } from "uuid";
import { handleMeetingSendMessage } from "@/baseComponents/Meeting/utils";
import GlobalContext from "@/context/GlobalContext";
import bus from "./bus";
import { DynamicObject } from "@/types/common";
import { log } from "@/utils/logger";

const { getOpenedServer } = utils;

const instanceMap: DynamicObject = {};

export enum PostMethod {
  Connected = "Connected",
  SendMainMessage = "SendMainMessage",
  SendChatMessage = "SendChatMessage"
}

class Response {
  static contextType = GlobalContext;
  static success(data: any) {
    const time = new Date().getTime();
    return {
      time,
      data,
      success: true,
      status: 1,
      error: null
    };
  }

  static failed(errMsg: any) {
    const time = new Date().getTime();
    return {
      time,
      data: null,
      success: false,
      status: 0,
      error: errMsg
    };
  }
}

class PostMessageService {
  /**
   * 获取当前实例
   * @param key string 实例标识
   * @param create boolean 当实例不存在，是否创建
   */
  public static getInstance(key: string, create = true): PostMessageService | null {
    if (!instanceMap[key]) {
      if (create) {
        instanceMap[key] = new PostMessageService(key);
      } else {
        return null;
      }
    }
    return instanceMap[key];
  }

  /**
   * 是否已和新标签页连接，连接状态可以发消息
   */
  connected: boolean;
  instanceKey: string;

  constructor(props: any) {
    this.connected = false;
    this.instanceKey = props.key || v4();
  }

  postMessage(method: string, payload?: any): Promise<any> {
    return Promise.reject(new Error("Method not implemented."));
  }

  /**
   * 事件处理函数
   */
  eventHandler(method: string, payload: any, response: Function) {
    log.debug("client received: ", method, payload);
    switch (method) {
      case PostMethod.Connected:
        response(Response.success(null));
        break;
      case PostMethod.SendChatMessage:
        handleMeetingSendMessage({
          avsdk: payload.avsdk,
          meetingInfo: {
            meetingNumber: payload.meetingNumber,
            meetingTopic: payload.meetingTopic,
            password: payload.password
          },
          sessionState: 1,
          toUsers: payload.toUsers
        })
          .then((res) => {
            response(Response.success(res));
          })
          .catch((err) => {
            response(Response.failed(err));
          });
        break;
      case PostMethod.SendMainMessage:
        if (payload.type) {
          let timemout: any;
          const cb = (res: any) => {
            bus.off(`${payload.type}:cb`, cb);
            timemout && clearTimeout(timemout);
            response(Response.success(res));
          };
          timemout = setTimeout(() => {
            bus.off(`${payload.type}:cb`, cb);
          }, 30000);
          bus.on(`${payload.type}:cb`, cb);
          bus.emit(`${payload.type}`, payload.data);
        }
        break;
      default:
        response(Response.failed("未知方法"));
        break;
    }
  }

  openServer(url: string, options: ClientOptions = {}) {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      const serverObject = getOpenedServer(url, options.clientInfo?.name);
      callServer(serverObject, {
        onDestroy: () => {
          this.connected = false;
          instanceMap[this.instanceKey] = null;
          Reflect.deleteProperty(instanceMap, this.instanceKey);
        },
        clientInfo: { name: "thisIsClient" + Math.random() },
        ...options
      })
        .then((e: any) => {
          log.debug("connected with server");
          this.connected = true;
          const { postMessage, listenMessage, destroy } = e;
          this.postMessage = postMessage;
          listenMessage((method: string, payload: any, response: any) => {
            this.eventHandler(method, payload, response);
            if (method === PostMethod.Connected) {
              resolve(payload);
            }
          });
        })
        .catch((err: any) => {
          log.error(err);
          reject(err);
        });
    });
  }
}

export default PostMessageService;
